import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserService } from '../../../../_Common/_Services/user.service'; 
import { GlobalSettingsService } from '../../../../_Common/_Services/global-settings.service'; 
import { catchError } from 'rxjs/operators';
import moment from 'moment';
import { DexieService } from '../../../../services/dexie/dexie.service'; 
@Injectable()
export class MFieldsService {

    constructor(
        private http: HttpClient,
        private userService: UserService,
        private globalSettings: GlobalSettingsService,
        private dexieService: DexieService
    ) { }

    // field
    getMFieldResponseTypes(dueId: any): Observable<any> {
        return this.http.get(`${this.globalSettings.getApiUrl()}/api/communicationManager/showCustomerResponseTemplates/field,whatsApp/?dueId=` + dueId)
            .pipe(
                catchError((e: any) => this.userService.getCheckError(e)));
    }

    // for add comment, instruction and escalation
    saveCommunicationDetails(saveCommentCommDetails: any, file?: any): Promise<any> {

        // below Api creates CommunicationDetail and Customer Response for Comment
        const url = '/api/timeline3/createCommDetailCustResponseForComment';
        let postBody: any = JSON.parse(JSON.stringify(saveCommentCommDetails)); // TODO: Parag. Shallow copy for now.
        const commentSaveUrl: string = this.globalSettings.getApiUrl() + url;
        const bulkCommentUrl: string = `${this.globalSettings.getApiUrl()}/api/timeline3/bulkComment`
        const formData: FormData = new FormData();
        if (file) {
            formData.append('file', file, file.name);
        }
        // First get the geolocation for the user
        return this.userService.getCurrentGeolocation()
            .then((geolocation: any) => {
                // Then save the geolocation in the comment
                if (!postBody.geolocation) {
                    postBody.geolocation = {
                        latitude: geolocation.coords.latitude,
                        longitude: geolocation.coords.longitude
                    };
                }
                if (this.userService.checkFieldAgentOnMobileIsOffline()) {
                    const { payObj } = postBody;
                    postBody.createdAt = moment().utc().format('YYYY-MM-DD HH:mm:ss');
                    formData.append('commentdata', JSON.stringify(postBody));
                    // The user is offline. Save it to an indexedDB so that it can be uploaded later.
                    return this.dexieService.getDexieFieldDBObj()
                        .add(
                            {
                                file,
                                isOffline: true,
                                type: 'field',
                                loggedInUserId: this.userService.getLoggedInUserId(),
                                url: commentSaveUrl,
                                postData: JSON.stringify(postBody),
                                paymentObj: payObj ? JSON.stringify(payObj): null
                            }
                        )
                        .then(() =>
                            Promise.resolve({
                                resultShort: 'offline',
                                resultLong:
                                    'You are offline. Synchronize the added comment when you get back online'
                            })
                        )
                        .catch((error: any) => {
                            console.log(error);
                        })

                    // The user is online. Save it to the server.
                }
                return this.saveCommentForAll(formData, postBody, bulkCommentUrl, commentSaveUrl);
            }).catch((err: any) => {
                console.log(err);
                // return this.saveCommentForAll(formData, postBody, bulkCommentUrl, commentSaveUrl);
            });
    }

    // check for the geolocation is availabe or not error handling
    saveCommentForAll(formData: any, postBody: any, bulkCommentUrl: any, commentSaveUrl: any): Promise<any> {
        formData.append('commentdata', JSON.stringify(postBody));
        if (postBody.dueIds) {
            return this.http.post(bulkCommentUrl, formData).toPromise();
        }
        return this.http.post(commentSaveUrl, formData).toPromise();
    }
}
